import SummarySetting from './SummarySetting';
export default SummarySetting;



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/summary-setting/index.jsx